import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DashboardData, Banner } from "src/app/shared/models/dashboard.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { Store } from "@ngrx/store";
import {
  dashboardData,
  ui_direction,
} from "src/app/shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { GET_DASHBOARD_DATA } from "src/app/shared/ngrx/ngrx-actions";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { EditBannersComponent } from "./edit-banners/edit-banners.component";

@Component({
  selector: "dash-banners",
  templateUrl: "./dash-banners.component.html",
  styleUrls: ["./dash-banners.component.scss"],
  imports: [
    ModalPopupComponent,
    CommonModule,
    TranslateModule,
    EditBannersComponent,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashBannersComponent implements OnInit {
  curBanner: Banner;
  allowEdit: boolean;
  displayEditBanners: boolean;
  switchBannerTimer: any;
  switchBannerIntervalSeconds: number = 10;
  destroy$ = new Subject();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  get isRTL(): boolean {
    return this.store.selectSignal(ui_direction)() == "rtl";
  }

  get curIdx(): number {
    if (!this.data) return 0;
    return this.data?.banners.indexOf(this.curBanner);
  }

  constructor(
    private readonly store: Store,
    private authService: AuthService,
    private actions$: Actions,
    private cdr: ChangeDetectorRef
  ) {
    this.allowEdit = this.authService.currentUser.org == "LAB";

    this.actions$
      .pipe(
        ofType(GET_DASHBOARD_DATA),
        takeUntil(this.destroy$),
        map(({}) => {
          this.setFirstItem();
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
    if (this.switchBannerTimer) {
      clearInterval(this.switchBannerTimer);
    }
  }

  ngOnInit(): void {
    this.setFirstItem();
  }

  setFirstItem() {
    if (this.data?.banners && this.data?.banners.length > 0)
      this.curBanner = this.data?.banners[0];
    else this.curBanner = null;

    if (this.switchBannerTimer) {
      clearInterval(this.switchBannerTimer);
    }

    if (this.curBanner != null) {
      this.switchBannerTimer = setInterval(() => {
        if (this.hasNext()) {
          this.next();
        } else {
          this.curBanner = this.data?.banners[0];
        }
        this.cdr.markForCheck();
      }, this.switchBannerIntervalSeconds * 1000);
    }
  }

  hasPrev(): boolean {
    return this.curIdx > 0;
  }

  hasNext(): boolean {
    if (!this.data) return false;
    return this.curIdx < this.data?.banners.length - 1;
  }

  next() {
    this.curBanner = this.data?.banners[this.curIdx + 1];
  }

  prev() {
    this.curBanner = this.data?.banners[this.curIdx - 1];
  }
}
